'use client';
import { jsx } from 'react/jsx-runtime';
import { useComboBox } from '@react-aria/combobox';
import { useFilter } from '@react-aria/i18n';
import { useComboBoxState } from '@react-stately/combobox';
import { createContext, useCallback, useRef, useMemo } from 'react';
import { useListboxList, SwanListboxListContext } from '../listbox/listbox-list.context.js';
import { HEIGHT_OF_OPTIONS_TO_SHOW } from '../listbox/listbox.context.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';
import { SwanPopoverContextProvider } from '../popover/popover.context.js';

const SwanComboboxContext = createContext(void 0);
function SwanComboboxContextProvider(l) {
    let { children: p, onSelectionChange: d, selectedKey: f, disableAutoFilter: v = false, 'aria-label': C, 'aria-labelledby': h, inputValue: S, defaultInputValue: y, onInputChange: w, menuTrigger: O = 'input', allowsCustomValue: g, allowEmptyCollection: P = false, maxHeight: E } = l, { childItems: _, items: H, disabledKeys: I } = useCollectionContext(), V = useCallback((o)=>{
        var t;
        let e = 'number' == typeof o ? o : null !== (t = null == o ? void 0 : o.toString()) && void 0 !== t ? t : '';
        null == d || d(null != e ? e : '');
    }, [
        d
    ]), { contains: j } = useFilter({
        sensitivity: 'base'
    }), k = useComboBoxState({
        children: _,
        items: H,
        defaultFilter: v ? void 0 : j,
        onSelectionChange: V,
        selectedKey: f,
        inputValue: S,
        defaultInputValue: y,
        onInputChange: w,
        allowsCustomValue: g,
        allowsEmptyCollection: P,
        menuTrigger: O
    }), A = useRef(null), B = useRef(null), F = useRef(null), M = useRef(null), R = useRef(null), { buttonProps: T, inputProps: X, listBoxProps: D, labelProps: G } = useComboBox({
        'aria-label': C,
        'aria-labelledby': h,
        menuTrigger: O,
        inputRef: B,
        buttonRef: A,
        listBoxRef: M,
        popoverRef: R,
        disabledKeys: I
    }, k), L = useModeExtractor(B, k.isOpen), U = useMemo(()=>({
            popoverRef: R,
            triggerRef: (null == F ? void 0 : F.current) ? F : B,
            overlayState: k,
            fullWidth: true,
            modes: L,
            maxHeight: null != E ? E : HEIGHT_OF_OPTIONS_TO_SHOW
        }), [
        B,
        R,
        F,
        k,
        L,
        E
    ]), W = useMemo(()=>({
            buttonProps: T,
            inputProps: X,
            labelProps: G,
            buttonRef: A,
            inputRef: B,
            triggerRef: F,
            setInputValue: k.setInputValue,
            menuTrigger: O
        }), [
        T,
        X,
        G,
        k,
        O
    ]), q = useListboxList(D, M, k);
    return jsx(SwanPopoverContextProvider, {
        value: U,
        children: jsx(SwanComboboxContext.Provider, {
            value: W,
            children: jsx(SwanListboxListContext.Provider, {
                value: q,
                children: p
            })
        })
    });
}
function useSwanComboboxContext() {
    return useNonNullishContext(SwanComboboxContext);
}

export { SwanComboboxContext, SwanComboboxContextProvider, useSwanComboboxContext };
